export enum eJSON_LINE_TYPE
{
  eNONE           = 0,    // Do not alter order or numbers.
  eSETTING_STD    = 1,    // These are used in the WEBAPP as well
  eMEASUREMENT    = 2,
  eBUTTON         = 3,
  eSTATUS         = 4,
  eSETTING_TEXT   = 5,
  eCOMPLEX        = 6,
  eSCALE          = 7,
  eDISPLAY_TYPE   = 8,
  eCONSTANT_VALUE = 9,
  eCARD_BRANCH    = 10,
}
